import { Checkbox, FormControlLabel } from '@mui/material';

import type { AssessmentReadinessNeededCheckboxProps } from './types';

export default function AssessmentReadinessNeededCheckbox({
  checked,
  disabled = false,
  onChange,
}: AssessmentReadinessNeededCheckboxProps) {
  return (
    <FormControlLabel
      sx={{ alignSelf: 'flex-start' }}
      control={
        <Checkbox
          checked={checked}
          disabled={disabled}
          onChange={(_event, value) => onChange(value)}
        />
      }
      label="Telehealth readiness assessment needed"
    />
  );
}
